// extracted by mini-css-extract-plugin
export default {"page":"lP","headerwrap":"mP","headerblock":"nP","textwrapper":"oP","text":"pP","closerlook":"qP","arrowwrap":"rP","icon":"sP","updown":"tP","products":"uP","system":"vP","systemimage":"wP","cards":"xP","note":"yP","fadein":"zP"};
    if(module.hot) {
      // 1713996748916
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  